<div class="flex justify-center px-8">
    <div class="w-3/5">
        <h2 class="text-center font-medium leading-relaxed text-2xl mt-8 p-4 text-yellow-100 rounded-md cursor-default"
            [ngClass]="{
          'cia': this.action.startsWith('CIA'),
          'dia': this.action.startsWith('DIA'),
          'gia': this.action.startsWith('GIA'),
          'pia': this.action.startsWith('PIA'),
          'wia': this.action.startsWith('WIA')
        }">
            {{this.action}}
            <br>
            ({{this.city}})
        </h2>
    </div>
</div>
<div class="my-8 items-center">
    <h4 class="flex justify-center mt-4 font-light leading-relaxed text-xl py-2 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Description</h4>
    <div *ngIf="allowed" class="desc-container flex justify-center flex-col items-center">
        <ng-container *ngIf="!editDesc; else descEditor">
            <div class="w-1/2 mx-auto my-2 p-4 rounded-md text-justify">
                <div [innerHTML]="description"></div>
            </div>
            <button
                class="px-2 py-1 border-evaluationfr text-evaluationto text-md font-light cursor-pointer hover:bg-evaluationto hover:text-blue-100 place-self-center"
                (click)="onDescEdit()">Edit</button>
        </ng-container>
        <ng-template #descEditor>
            <quill-editor [modules]="QuillConfiguration" [(ngModel)]="description"
                (onContentChanged)="onContentChanged('description', $event)" (click)="onFocus('description')"
                class="w-1/2 mx-auto my-2 p-4 rounded-md text-justify">
            </quill-editor>
            <div *ngIf="descEdited && descFocused">
                <button
                    class="px-2 py-1 border-evaluationfr text-evaluationto text-md font-light cursor-pointer hover:bg-evaluationto hover:text-blue-100 place-self-center"
                    (click)="onDescriptionSave()">Update Description</button>
            </div>
        </ng-template>
    </div>
    <div *ngIf="!allowed" class="desc-container flex justify-center flex-col items-center">
        <div class="w-1/2 mx-auto bg-transparent whitespace-normal break-words text-justify font-light leading-relaxed text-lg my-2 p-4 text-gray-800 cursor-default"
            [innerHTML]="description">
        </div>
    </div>
</div>
<div class="my-8 items-center">
    <h4 class="flex justify-center font-light leading-relaxed text-xl py-2 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Objective</h4>
    <div *ngIf="allowed" class="obj-container flex justify-center flex-col items-center">
        <ng-container *ngIf="!editObj; else objEditor">
            <div class="w-1/2 mx-auto bg-transparent whitespace-normal break-words text-justify font-light leading-relaxed text-lg my-2 p-4 text-gray-800 cursor-default"
                [innerHTML]="objective">
            </div>
            <button
            class="px-2 py-1 border-evaluationfr text-evaluationto text-md font-light cursor-pointer hover:bg-evaluationto hover:text-blue-100 place-self-center"
            (click)="onObjEdit()">Edit</button>
        </ng-container>
        <ng-template #objEditor>
            <quill-editor [modules]="QuillConfiguration" [(ngModel)]="objective"
                (onContentChanged)="onContentChanged('objective', $event)" (click)="onFocus('objective')"
                class="w-1/2 mx-auto my-2 p-4 rounded-md text-justify">
            </quill-editor>
            <div *ngIf="objEdited && objFocused">
                <button
                    class="px-2 py-1 border-evaluationfr text-evaluationto text-md font-light cursor-pointer hover:bg-evaluationto hover:text-blue-100 place-self-center"
                    (click)="onObjectiveSave()">Update Objective</button>
            </div>
        </ng-template>

    </div>
    <div *ngIf="!allowed" class="obj-container flex justify-center flex-col items-center">
        <div class="w-1/2 mx-auto bg-transparent whitespace-normal break-words text-justify font-light leading-relaxed text-lg my-2 p-4 text-gray-800 cursor-default"
            [innerHTML]="objective">
        </div>
    </div>
</div>
<div class="my-8 items-center">
    <h4 class="flex justify-center font-light leading-relaxed text-xl py-2 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Media</h4>
    <div *ngIf="allowed" class="obj-container flex justify-center flex-col items-center">
        <ng-container *ngIf="!editMedia; else mediaEditor">
            <div class="w-1/2 mx-auto my-2 p-4 rounded-md text-justify">
                <div [innerHTML]="sanitizeMedia()"></div>
            </div>
            <button
                class="px-2 py-1 border-evaluationfr text-evaluationto text-md font-light cursor-pointer hover:bg-evaluationto hover:text-blue-100 place-self-center"
                (click)="onMediaEdit()">Edit</button>
        </ng-container>
        <ng-template #mediaEditor>
            <quill-editor [modules]="QuillConfiguration" [(ngModel)]="media"
                (onContentChanged)="onContentChanged('media', $event)"
                class="w-1/2 mx-auto my-2 p-4 rounded-md text-justify">
            </quill-editor>
            <div class="flex justify-center space-x-2">
                <button
                    class="px-2 py-1 border-evaluationfr text-evaluationto text-md font-light cursor-pointer hover:bg-evaluationto hover:text-blue-100 place-self-center"
                    (click)="saveMedia()">Save</button>
            </div>
        </ng-template>
    </div>
    <div *ngIf="!allowed" class="obj-container flex justify-center flex-col items-center">
        <div
            class="w-1/2 mx-auto bg-transparent whitespace-normal break-words text-justify font-light leading-relaxed text-lg my-2 p-4 text-gray-800 cursor-default">
            <div [innerHTML]="sanitizeMedia()"></div>
        </div>
    </div>
</div>
<div *ngIf="isLoggedIn">
    <div class="flex justify-center">
        <h3 class="font-thin my-2 leading-relaxed text-lg text-gray-800 cursor-default"
            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            KPIs for this action:
        </h3>
    </div>
    <div class="w-3/5 p-8 mx-auto">
        <div class="shadow">
            <div class="border-b">
                <div class="border-l-2 border-transparent">
                    <ng-container *ngFor="let kpi of kpis;">
                        <div class="shadow">
                            <div class="border-b">
                                <div class="border-l-2 border-transparent">
                                    <div class="grid grid-cols-1 text-grey-800 text-justify">
                                        <div class="flex justify-between items-center p-1 text-lg font-thin cursor-pointer rounded hover:bg-colortext hover:text-yellow-200"
                                            (click)="onClick($event.target.value)" value="{{kpi.Kpi}}">
                                            {{kpi.Kpi}}
                                            <div class="rounded-full border border-grey w-7 h-7 flex ml-4 items-center justify-center pointer-events-none"
                                                *ngIf="!kpi.expanded">
                                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24"
                                                    stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" viewbox="0 0 24 24" width="24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <polyline points="6 9 12 15 18 9">
                                                    </polyline>
                                                </svg>
                                            </div>
                                            <div class="rounded-full border border-grey w-7 h-7 flex ml-4 items-center justify-center pointer-events-none"
                                                *ngIf="kpi.expanded">
                                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24"
                                                    stroke="#606F7B" stroke-linecap="round" stroke-linejoin="round"
                                                    stroke-width="2" viewbox="0 0 24 24" width="24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <polyline points="18 15 12 9 6 15">
                                                    </polyline>
                                                </svg>
                                            </div>
                                        </div>
                                        <div *ngIf="kpi.expanded">
                                            <div class="grid grid-cols-2">
                                                <div *ngFor="let data of barChartData">
                                                    <div class="place-self-center">
                                                        <canvas *ngIf="!this.is9 && !this.is43 && !this.is44" baseChart
                                                            width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels" [options]="barChartOptions"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                        <canvas *ngIf="this.is43" baseChart width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels" [options]="barChartOption43"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                        <canvas *ngIf="this.is44" baseChart width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels" [options]="barChartOptions44"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                        <canvas *ngIf="this.is9" baseChart width="600" height="500"
                                                            [datasets]="data.barchartDataObject"
                                                            [labels]="barChartLabels9" [options]="barChartOptions"
                                                            [colors]="chartColors" [chartType]="barChartType">
                                                        </canvas>
                                                        <div *ngIf="this.is30" class="text-sm font-light text-gray-600"
                                                            [innerHTML]="kpi30notes"></div>
                                                    </div>
                                                </div>
                                                <div *ngIf="this.allowed">
                                                    <div class="text-center">
                                                        <h2 class="my-2">Click below to complete the corresponding
                                                            questionnaire:</h2>
                                                    </div>
                                                    <div class="flex flex-col place-self-center">
                                                        <button
                                                            class="border-blue-400 font-light rounded p-4 m-2 px-4 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onBaseline()">
                                                            <div class="text-lg">Baseline</div>
                                                        </button>
                                                        <button
                                                            class="border-blue-400 font-light rounded p-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onM24()">
                                                            <div class="text-xl">M24</div>
                                                        </button>
                                                        <button
                                                            class="border-blue-400 font-light rounded  p-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onM36()">
                                                            <div class="text-xl">M36</div>
                                                        </button>
                                                        <button
                                                            class="border-blue-400 font-light rounded p-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center"
                                                            (click)="onM42()">
                                                            <div class="text-xl">M42</div>
                                                        </button>
                                                        <button (click)="onInfo()"
                                                            class="border-blue-400 font-light rounded p-4 px-4 m-2 bg-evaluationfr hover:bg-evaluationhover text-blue-100 hover:text-blue-400 place-self-center">
                                                            <i class="fas fa-info text-3xl"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="w-1/5" style="position: fixed; top: 25%; bottom: 0; overflow-y: auto; z-index: 5000;">
        <div class="bg-white shadow">
            <div class="border-b">
                <div class="border-l-2 border-transparent">
                    <ng-container *ngFor="let data of data; index as i;">
                        <div class="grid grid-cols-1 text-grey-800 text-justify">
                            <div class="flex justify-center text-md py-2 px-1 font-light rounded-md cursor-pointer text-gray-100"
                                [class.cia]="data.Action_Cat === 'CIA-FOOD CONSUMER'"
                                [class.dia]="data.Action_Cat === 'DIA-FOOD DISTRIBUTION'"
                                [class.gia]="data.Action_Cat === 'GIA-FOOD GOVERNANCE'"
                                [class.pia]="data.Action_Cat === 'PIA-FOOD PRODUCTION AND PROCESSING'"
                                [class.wia]="data.Action_Cat === 'WIA-FOOD WASTE'"
                                (click)="onClickAgain($event.target.value)" value="{{data.Action_Cat}}">
                                {{data.Action_Cat}} &nbsp;
                                <i *ngIf="!data.expanded" class="fas fa-chevron-down text-md pointer-events-none"></i>
                                <i *ngIf="data.expanded" class="fas fa-chevron-up text-md pointer-events-none"></i>
                            </div>
                            <div *ngIf="data.expanded">
                                <div *ngFor="let action of actions[i]">
                                    <div class="shadow">
                                        <div class="border-b">
                                            <div class="border-l-2 border-transparent">
                                                <div class="p-1 text-md font-thin rounded hover:bg-colortext hover:text-yellow-200 cursor-pointer"
                                                    (click)="onActionClickAgain(action)">
                                                    {{action}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<swal></swal>